import { withInstall } from '../../utils'

import _Icon from './src/icon.vue'

export const SdIcon = withInstall(_Icon)
export default SdIcon

export * from './src/icon'
